import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  Row,
  Col,
  Select,
  Upload,
  message,
  Switch,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { getBase64, beforeUpload } from "../../../utils/handlePhoto";
import API from "../../../services/api-request";
import { baseUrl } from "../../../config/url-config";

const EditUsers = (props) => {
  const [editForm] = Form.useForm();
  const [changePassword, setChangePassword] = useState(false);
  const [privilegeOptions, setPrivilegeOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);

  const getPrivilegeOptions = async (general_role) => {
    await API.Get(`privilege?generale_role=${general_role}`)
      .then((result) => {
        setPrivilegeOptions(
          result.data.map((e) => {
            return { value: e.id, label: e.name };
          })
        );
      })
      .catch((err) => {
        message.info("Failed Fetch Data Privilege!");
        console.error(err);
      });
  };

  const getClientOptions = async () => {
    await API.Get("client")
      .then((result) => {
        setClientOptions(
          result.data.map((e) => {
            return { value: e.id, label: e.name };
          })
        );
      })
      .catch((err) => {
        message.info("Failed Fetch Data Client!");
        console.error(err);
      });
  };

  const onValuesChange = (changedValues, allValues) => {
    getPrivilegeOptions(allValues.general_role);
    if (
      changedValues.general_role === "admin" ||
      changedValues.general_role === "client"
    )
      editForm.setFieldValue("privilege_id", null);
  };

  const onFinish = async (values) => {
    const {
      name,
      email,
      username,
      password,
      privilege_id,
      general_role,
      client_id,
      image,
    } = values;

    const dataForm = {
      name,
      email,
      username,
      password: password ?? "",
      privilege_id,
      general_role,
      client_id: client_id ?? "",
      image,
      id: props.selectedData.id,
    };

    const formData = new FormData();

    for (const property in dataForm) {
      formData.append(`${property}`, dataForm[property]);
    }
    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ", " + pair[1]);
    // }

    await API.Post("user/update", formData)
      .then(() => {
        message.success("User has been saved");
        props.onGetUsers();
        setChangePassword(false);
        editForm.resetFields();
        setFileList([]);
        props.onShowEdit(false);
      })
      .catch((err) => {
        console.error(err);
        if (!err.response.data) {
          message.info("Failed update user");
        }

        message.info(
          `${err.response.data.errors[0].path} ${err.response.data.errors[0].msg}`
        );
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowEdit(false);
    setChangePassword(false);
    editForm.setFieldsValue({});
  };

  // File Upload Variable & Function
  const [fileList, setFileList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  const dummyRequest = ({ onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const getFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }

    return e && e.file.originFileObj;
  };

  useEffect(() => {
    if (!props.selectedData) return;
    getPrivilegeOptions(props.selectedData?.privilege?.generale_role);
    getClientOptions();
    editForm.setFieldsValue({
      ...props.selectedData,
      general_role: props.selectedData?.privilege?.generale_role,
    });
    setFileList([
      {
        url: `${baseUrl}/${props.selectedData.image}`,
      },
    ]);
    console.log(props.selectedData);
  }, [props.selectedData]);

  return (
    <>
      <Modal
        title="Edit Users"
        open={props.showEdit}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={() => editForm.submit()}>
            Save
          </Button>,
        ]}
      >
        <Form
          form={editForm}
          name="Edit Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onValuesChange={onValuesChange}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Please input your name!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please input your email!" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Switch
                size="small"
                onChange={() => setChangePassword(!changePassword)}
                checked={changePassword}
              />
            </Col>
            <Col span={12}>
              <Form.Item
                label="Change Password"
                name="password"
                rules={[
                  {
                    required: changePassword,
                    message: "Please input your password!",
                  },
                ]}
              >
                <Input.Password disabled={!changePassword} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Confirm Password"
                name="password2"
                dependencies={["password"]}
                rules={[
                  {
                    required: changePassword,
                    message: "Please input your confirm password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (
                        !changePassword ||
                        !value ||
                        getFieldValue("password") === value
                      ) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "The new password that you entered do not match!"
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password disabled={!changePassword} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Client" name="client_id">
                <Select options={clientOptions} allowClear />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Username"
                name="username"
                rules={[
                  { required: true, message: "Please input your username!" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="General Role"
                name="general_role"
                rules={[
                  {
                    required: true,
                    message: "Please input your general role!",
                  },
                ]}
              >
                <Select
                  options={[
                    { value: "admin", label: "Admin" },
                    { value: "client", label: "Client" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Privilege"
                name="privilege_id"
                rules={[
                  { required: true, message: "Please input your privilege!" },
                ]}
              >
                <Select options={privilegeOptions} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Row>
                <Col span={11}>
                  <Form.Item
                    label="Upload Photo"
                    name="image"
                    getValueFromEvent={getFile}
                  >
                    <Upload
                      maxCount={1}
                      customRequest={dummyRequest}
                      listType="picture-card"
                      fileList={fileList}
                      beforeUpload={beforeUpload}
                      onPreview={handlePreview}
                      onChange={handleChange}
                    >
                      {fileList.length >= 1 ? null : (
                        <button
                          style={{ border: 0, background: "none" }}
                          type="button"
                        >
                          <PlusOutlined />
                          <div style={{ marginTop: 8 }}>Upload</div>
                        </button>
                      )}
                    </Upload>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <ul style={{ fontSize: "10px" }}>
                    <li>Must be {"<"} 2MB!</li>
                    <li>Must be JPEG/PNG</li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        open={previewOpen}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
    </>
  );
};
export default EditUsers;
